'use strict';

var classNames = {
	screenSizeDetector: 'screen-size-detector',
	disableScroll: 'disable-scroll'
};

function getScreenSize() {
	return $.findByBem(classNames.screenSizeDetector).css('font-family').toUpperCase();
}

export default {
	getScreenSize: getScreenSize,

	isDesktop() {
		var screenSize = getScreenSize();
		return screenSize === 'L' || screenSize === 'XL' || screenSize === 'XXL';
	},

	isMobile() {
		var screenSize = getScreenSize();
		return screenSize === 'S';
	},

	isIOS() {
		if (!navigator.platform) {
			return false;
		}

		if (/iPad|iPhone|iPod/.test(navigator.platform)) {
			return true;
		}

		if (/MacIntel/.test(navigator.platform)) {
			// iPad iOS 13+ returns same platform as MacBook, so we test touchscreen as hacky workaround
			return !!navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
		}

		return false;
	},

	disablePageScrolling() {
		const $html = $('html');
		const scrollTop = $(window).scrollTop();
		$html.addClass(classNames.disableScroll);

		// Offset html top to maintain current scroll position when scrolling is disabled
		if ($(document).height() > $(window).height()) {
			$html.css('top', -scrollTop);
		}
	},

	enablePageScrolling() {
		const $html = $('html');

		if (!$html.is('.' + classNames.disableScroll)) {
			return;
		}

		const scrollTop = parseInt($html.css('top'), 10);
		$html.removeClass(classNames.disableScroll);

		// Restore correct scroll position when scrolling is enabled
		if ($(document).height() > $(window).height()) {
			$html.css('top', '');
			$(window).scrollTop(-scrollTop);
		}
	},

	automaticallyDisplayOffCanvas(offCanvasSelector) {
		$(document).ready(function () {
			// Timeouts and manual styling to avoid race conditions initialising foundation with react views etc
			window.setTimeout(() => {
				const $offCanvas = $(offCanvasSelector);
				$offCanvas.removeClass('is-closed').addClass('is-open').attr('aria-hidden', 'false');
				$offCanvas.siblings('.js-off-canvas-overlay').addClass('is-visible');
			}, 500);
		});
	}
}